import type {CountryCode} from '@commercial-website/data-layer/locale'
import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'

import {getDefaultLocale} from '@/providers/locale'
import type {HubspotState} from '@/utils/submit-hubspot-form'

export const useMappedHubspotPayload = () => {
    const defaultLocale = getDefaultLocale()
    countries.registerLocale(en)

    return (payload: HubspotState) => ({
        ...payload,
        ...(payload.country && {
            country:
                payload.country === 'Other'
                    ? payload.country
                    : countries.getName(payload.country as CountryCode, defaultLocale.language),
        }),
    })
}
